import React from 'react';
import ChamadoStatusCard from './ChamadoStatusCard';

function ChamadoSidebarSolicitante({ statusNome, anexosCard, anexosCardRef }) {
    return (
        <aside className="chamado-sidebar">
            <ChamadoStatusCard readOnly statusNome={statusNome} />
            {anexosCard != null && (
                <div className="chamado-sidebar-card chamado-sidebar-anexos-wrap" ref={anexosCardRef}>
                    {anexosCard}
                </div>
            )}
        </aside>
    );
}

export default ChamadoSidebarSolicitante;
